module.exports = __webpack_public_path__ + "static/media/21ECLAC33.0aca8353.jpg";